import { state } from './types';

export default {
  [state.NOTIFICATION]: null,
};
